package com.taocent.simple.compose.component

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlin.js.JsArray
import kotlin.js.JsNumber

/**
 * jsMain actual:用 window.fetch + arrayBuffer 拿字节。
 * js 端 dynamic 类型可用,Uint8Array 走 dynamic JS 路径转 ByteArray。
 */
internal actual suspend fun fetchFontBytes(
    url: String,
    onProgress: (Float) -> Unit,
): ByteArray {
    val response = window.fetch(url, js("undefined")).await()
    if (!response.ok) {
        throw IllegalStateException("HTTP ${response.status} fetching $url")
    }
    onProgress(0.4f)
    val buf: dynamic = response.arrayBuffer().await()
    val u8: dynamic = js("new Uint8Array(buf)")
    onProgress(0.95f)
    val arr = u8.unsafeCast<JsArray<JsNumber>>().toArray()
    val out = ByteArray(arr.size) { i -> arr[i].toInt().toByte() }
    onProgress(1f)
    return out
}
